<template>
    <div class="page-container">
        <div class="page-header">
            登录/注册后采集
        </div>
        <div class="login-form">
            <div class="logo">
                <img src="../../../images/logo-w.png" alt="">
            </div>
            <div class="form">
                <form v-if="activeSign==='sign-form'" class="sign-form">
                    <div class="errorMsg">
                        {{errorMsg.login}}
                    </div>
                    <div class="input-div">
                        <i class="iconfont icon-phone"></i>
                        <input @blur="checkPhone(user.phone)" type="number" placeholder="请输入手机号码" v-model="user.phone"
                               @input="inputPhone()">
                    </div>
                    <div class="input-div identify-code-div">
                        <input type="text" placeholder="输入验证码" maxlength="8" v-model="user.code"
                               @keyup="keyup($event,'login')">
                        <button class="submit-btn" @click="getCode('login')" type="button" :disabled="timer > 0 ? true : false">
                            <span v-if="timer > 0">{{timer}}s 后重新发送</span>
                            <span v-else>{{hasSendMsg ? '重新发送' : '获取验证码'}}</span>
                        </button>
                    </div>
                    <div>
                        <button class="green-btn" style="width:240px" @click="login" type="button">登录</button>
                    </div>
                    <p class="cut-off">或</p>
                    <div>
                        <button class="yellow-btn" style="width:240px" @click="activeSignHandle('sign-app')" type="button"><i
                                class="iconfont icon-scancode"></i>APP扫码登录
                        </button>
                    </div>
                </form>
                <div v-if="activeSign==='sign-app'" class="sign-app">
                    <div class="code" v-if="appCodeImg">
                        <img :src="appCodeImg" alt="">
                        <div v-if="isInvalid >= 200" class="Invalid">
                            <p>二维码已失效</p>
                            <span @click="refreshCode">请点击刷新</span>
                        </div>
                    </div>
                    <p class="scan-text" v-if="appCodeImg"><span class="red-font"><i class="iconfont icon-scancode"></i></span>打开<span class="yellow-font">手机住逻辑</span>扫一扫登录</p>
                    <p class="cut-off">或</p>
                    <div>
                        <button class="cyan-btn" style="width:240px" @click="activeSignHandle('sign-form')" type="button"><i class="iconfont icon-phone"></i>验证码快速登录
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-model="colImgValidator" class="colImgValidator imgValidator" width="360">
            <div class="close-btn" slot="close">
                <i class="iconfont icon-pop-close"></i>
            </div>
            <div slot="header" class="title">请输入验证码</div>
            <img-validate-modal ref="colImgValidator" :phone="user.phone" @sendMsg="sendMsgBegin"></img-validate-modal>
        </Modal>
    </div>
</template>
<script>
    import api from '../../../api/index'
    import validator from '../account/validator';
    import util from '../../../libs/util'
    import imgValidateModal from '../account/imgValidateModal.vue'


    const reg_phone = validator.reg_phone;

    export default{
        data(){
            return {
                colImgValidator: false,
                user: {
                    phone:  '',
                    code: ''
                },
                errorMsg: {
                    login: '',
                },
                hasSendMsg: false,
                nextRouter: '',
                timer: 0,
                timerCode:0,
                timerInterval: () => {
                },
                activeSign: 'sign-form',
                appCodeImg: undefined,
                isInvalid: 0
            }
        },
        components:{
            imgValidateModal
        },
        methods: {
            inputPhone() {
                this.user.phone = Number(String(this.user.phone).slice(0, 11)) || '';
            },
            getCode(type) {
                if(this.validate('login')) {
                    api.account.verify_img_code({
                        phone: this.user.phone,
                        messageType: 3
                    })
                        .then((re) => {
                            if (re) {
                                this.sendMsgBegin();
                            } else {
                                this.$refs.colImgValidator.open(type);
                                this.colImgValidator = true;
                            }
                        });
                }
            },
            sendMsgBegin() {
                this.closeImgValidator();
                let that = this;
                if(util.getCookie('CollectCountDown')){
                    let nowTimer = new Date()
                    nowTimer = new Date(nowTimer)
                    let newAfterMin =  (nowTimer.getTime() - new Date(util.getCookie('CollectCountDown')).getTime())/1000
                    if(newAfterMin < 90){
                        that.timer =Math.floor(90 - newAfterMin)
                    }else{
                        util.setCookie('CollectCountDown',"" ,-1)
                        clearInterval(that.timerInterval);
                    }
                }else{
                    that.timer = 90
                }
                !this.hasSendMsg && (this.hasSendMsg = true);
                that.timerInterval = setInterval(function () {
                    that.timer--;
                    util.setCookie('CollectCountDown', that.timer);
                    if (that.timer == 0) {
                        util.setCookie('CollectCountDown', "", -1)
                        clearInterval(that.timerInterval);
                    }
                }, 1000);
            },
            checkPhone() {
                this.validate('login');
            },
            validate(type) {
                if (this.user.phone) {
                    if (type === 'login' && !reg_phone.test(this.user.phone)) {
                        this.errorMsg[type] = '您输入的手机号不符合规则';
                        return false;
                    }
                } else {
                    this.errorMsg[type] = '手机号必填';
                    return false;
                }
                if (type != 'login') {
                    if (!this.user.code) {
                        this.errorMsg[type] = '验证码必填';
                        return false;
                    }
                }
                this.errorMsg[type] = '';
                return true;
            },
            keyup(e, func) {
                if (e.keyCode == 13) {
                    this[func]();
                }
            },
            getUuid(){
                api.appCode.getUuid()
                    .then(res => {
                        this.appCodeImg = 'data:image/png;base64,' + Object.values(res)[0]
                        this.uuid = Object.keys(res)[0]
                    })
            },
            login() {
                api.account.login_quick({
                    'phone': this.user.phone,
                    'code': this.user.code,
                    'messageType': 3
                })
                    .then((res) => {
                        this.setToken(res);
                        this.$store.dispatch('getUser')
                        this.goBack();
                    }, (err) => {
                        this.errorMsg['login'] = err.data.message;
                    })
            },
            setToken(token) {
                this.$store.dispatch('setToken', token);
            },
            refreshCode() {
                this.getUuid();
                this.isInvalid = 0
            },
            activeSignHandle(name){
                this.activeSign = name
                if (name === 'sign-app') {
                    this.checkLogin(this.uuid)
                    clearInterval(this.timer)
                } else {
                    clearInterval(this.timerCode)
                }
            },
            checkLogin(uuid) {
                this.timerCode = setInterval(() => {
                    this.isInvalid ++;
                    api.appCode.checkLogin(uuid)
                        .then(res => {
                            if(res.login){
                                let token = {
                                    'accessToken' : res.token
                                }
                                this.setToken(token);
                                this.$store.dispatch('getUser')
                                clearInterval(this.timerCode);
                                this.goBack();
                            }
                        }, (err) => {
                            this.errorMsg['login'] = err.data.message;
                        })
                }, 1500)

            },
            closeImgValidator() {
                this.colImgValidator = false;
            },
            goBack(){
                this.$router.push(this.$route.query.redirect||{name:'widgetsBatchCollect'});
            }
        },
        created(){
            this.getUuid();
            if(util.getCookie('CollectCountDown')){
                this.sendMsgBegin()
            }
        },
        destroyed() {
            clearInterval(this.timer)
            clearInterval(this.timerCode)
        }
    }
</script>
<style>
    @media (max-width: 768px){
        .colImgValidator .ivu-modal{
            width:360px !important;
            margin: 0 auto;
        }
    }
</style>
<style scoped type="text/scss" lang="scss">
    .page-container {
        .page-header{
            height:90px;
            line-height:90px;
            font-size:24px;
            letter-spacing: 4px;
            text-align: center;
        }
        button{
            line-height:40px;
            height:40px;
            font-size:14px;
        }
        button i{
            vertical-align: middle;
        }
        .login-form {
            background-image: url('./images/login-widgets-bg.png');
            background-size: cover;
            background-repeat: no-repeat;
            padding-top: 80px;
            height:550px;
            box-sizing: border-box;
            .logo {
                width: 80px;
                margin: 0 auto;
            }
            .form {
                width:240px;
                margin:0 auto;
                .sign-form{
                    padding-top:60px;
                    position:relative;
                    .errorMsg{
                        color:red;
                        text-align: left;
                        line-height:20px;
                        position:absolute;
                        top:40px;
                    }
                    .input-div {
                        width: 240px;
                        height:40px;
                        margin: 0 auto 30px;
                        position: relative;
                        input {
                            background: #FFFFFF;
                            border-radius: 4px;
                            border: 0 none;
                            width: 100%;
                            height:100%;
                            padding-left:44px;
                        }
                        i.iconfont {
                            position: absolute;
                            top: 9px;
                            left: 22px;
                            font-size: 14px;
                            color:#A2A2A8;
                        }
                        &.identify-code-div {
                            input {
                                width: 115px;
                                padding-left:24px;
                            }
                            button {
                                width: 115px;
                                margin-left: 6px;
                                background: #FFFFFF;
                                line-height:36px;
                                border: 2px solid #308697;
                                color:#308697;
                                border-radius: 4px;
                                box-sizing: border-box;
                                font-size: 14px;
                            }
                        }
                    }
                    .yellow-btn{
                        background: rgba(255,193,7,1);
                        border-radius: 4px;
                        color:#fff;
                        font-size:14px;
                        &:hover{
                            background: rgba(255,193,7,0.9);
                        }
                        i.iconfont{
                            font-size:18px;
                            margin-right:16px;
                        }
                    }
                    .cut-off{
                        margin-top:12px;
                    }
                }
                .sign-app{
                    margin-top:30px;
                    .code{
                        margin-bottom:24px;
                        img{
                            width:164px;
                            display:block;
                            margin:0 auto;
                        }
                    }
                    p{
                        &.scan-text{
                            color:#fff;
                            line-height:22px;
                            text-align: center;
                        }
                        &.cut-off{
                        }
                        .yellow-font{
                            color:#F4D03C;
                            font-size:14px;
                        }
                        .icon-scancode{
                            font-size:20px;
                            margin-right:10px;
                            vertical-align: middle;
                        }
                    }
                    .cyan-btn{
                        background-color:rgba(51,189,205,1);
                        color:#fff;
                        &:hover{
                            background-color:rgba(51,189,205,0.9);
                        }
                        .iconfont{
                            font-size:18px;
                            margin-right:14px;
                        }
                    }
                }
                .cut-off {
                    line-height: 18px;
                    margin:10px 0;
                    font-size: 12px;
                    color: #A2A2A8;
                    position: relative;
                    text-align: center;
                    &:before,
                    &:after {
                        width: 42px;
                        height: 1px;
                        background-color: #A2A2A8;
                        position: absolute;
                        top: 8px;
                        content:'';
                    }
                    &:before {
                        left: 64px;
                    }
                    &:after {
                        right: 64px;
                    }

                }
            }
        }
    }
</style>
